import styled, { css } from 'styled-components/macro';
import {
  DoneProps,
  RecordingProgressProps,
  SliderProps,
  WrapperProps,
} from './types';

export const Done = styled.div<DoneProps>`
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: 0;
  width: ${({ position }) => `${position}%`};
  background: ${({ background }) => background};
  border-radius: 8px;
  max-width: 100%;
`;

export const RecordingInfo = styled.div`
  box-sizing: border-box;
  width: 100px;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 13px;
`;

export const MicIconWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 17px;
  padding-top: 4px;
`;

export const CurrentTime = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${props => props.theme.colors.secondary[100]};
`;

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 11px;
  margin: 0;
  width: 696px;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
    `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const RecordingProgress = styled.div<RecordingProgressProps>`
  position: relative;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  align-items: center;
  background: ${props => props.theme.colors.neutral[10]};
  border: ${props => `1px solid ${props.theme.colors.white[100]}`};
  padding-right: 13px;

  border-radius: 6px;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const ProgressBar = styled.div`
  position: relative;
  height: 12px;
  width: 100%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: ${props => props.theme.colors.white[100]};
`;

export const Slider = styled.input<SliderProps>`
  -webkit-appearance: none;
  width: 100%;
  background: transparent;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 3;
  cursor: pointer;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 4px;
    height: 40px;
    margin-top: 6px;
    z-index: 3;
  }
  &::-moz-range-thumb {
    width: 4px;
    height: 40px;
    margin-top: 6px;
    z-index: 3;
  }
  &::-ms-thumb {
    width: 4px;
    height: 40px;
    z-index: 3;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      &::-webkit-slider-thumb {
        display: none;
      }
      &::-moz-range-thumb {
        display: none;
      }
      &::-ms-thumb {
        display: none;
      }
    `};
  &:focus {
    outline: none;
  }
  &::-ms-track {
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
`;

export const Audio = styled.audio`
  display: none;
`;
